"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
const react_1 = __importDefault(require("react"));
const Notification_styles_1 = require("./Notification.styles");
const Notification = ({ title, subTitles }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Notification_styles_1.NotificationWrapper, null,
            react_1.default.createElement(Notification_styles_1.Title, null, title),
            react_1.default.createElement(Notification_styles_1.HorizontalLine, null),
            subTitles.map((ele, index) => (react_1.default.createElement(Notification_styles_1.Name, { key: index },
                react_1.default.createElement(Notification_styles_1.Subtitle, { onClick: () => ele.onClick() }, ele.name),
                ele.subPoints.map((sp, i) => (react_1.default.createElement(Notification_styles_1.SubPoint, { key: index + i },
                    "-",
                    sp))),
                index < subTitles.length - 1 && react_1.default.createElement(Notification_styles_1.HorizontalLine, null)))))));
};
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map